import React from "react";
import { Card, CardBody, CardTitle, Row, Col, Button } from "reactstrap";

const formatDate = (dateStr) => {
    if (!dateStr || dateStr === "N/A") return "N/A";
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return dateStr;
    return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
};

const TravelSummary = ({
    Company,
    documentType,
    geographicalCover,
    duration,
    amtDays,
    travellers,
    age,
    startDate,
    endDate,
    criticalIllness,
    onBack,
}) => {
    const isAmtType = String(documentType || "")
        .trim()
        .toLowerCase()
        .includes("amt");
    const daysLabel = isAmtType ? "AMT Plan Days" : "Number of Days";
    const daysValue = isAmtType ? (amtDays || "N/A") : (duration || "N/A");

    const summaryCardStyle = {
        marginTop: "8px",
        borderRadius: "16px",
        border: "1px solid #d8e1ee",
        backgroundColor: "#ffffff",
        boxShadow: "0 8px 24px rgba(15, 23, 42, 0.06)",
    };

    const stripStyle = {
        border: "1px solid #d7e1ef",
        borderRadius: "14px",
        backgroundColor: "#f8fbff",
        overflow: "hidden",
    };

    const segmentStyle = {
        padding: "10px 12px",
        minHeight: "74px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: "4px",
    };

    const segmentLabelStyle = {
        color: "#64748b",
        fontSize: "0.84rem",
        fontWeight: 600,
        marginBottom: 0,
        lineHeight: 1.2,
    };

    const segmentValueStyle = {
        color: "#0f2d5c",
        fontSize: "1.01rem",
        fontWeight: 700,
        marginBottom: 0,
        lineHeight: 1.25,
    };

    const iconWrapStyle = {
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
    };

    const infoValue = travellers?.replace(/DOB\s*:\s*/i, "") || "N/A";
    const ageValue = age || "N/A";
    const topSegments = [
        { key: "company", icon: "fa-building-o", label: "Company", value: Company || "N/A" },
        { key: "type", icon: "fa-file-text-o", label: "Type", value: documentType || "N/A" },
        { key: "cover", icon: "fa-globe", label: "Geographical Cover", value: geographicalCover || "N/A" },
        { key: "dob", icon: "fa-user", label: "Date of Birth", value: infoValue },
        { key: "age", icon: "fa-user", label: "Age", value: ageValue },
        { key: "critical", icon: "fa-heartbeat", label: "Critical Illness", value: criticalIllness || "N/A" },
    ];

    const bottomSegments = [
        { key: "start", icon: "fa-calendar", label: "Start Date", value: formatDate(startDate) },
        { key: "end", icon: "fa-calendar", label: "End Date", value: formatDate(endDate) },
        { key: "days", icon: "fa-calendar-check-o", label: daysLabel, value: daysValue },
    ];

    return (
        <Card className="mb-2" style={summaryCardStyle}>
            <CardBody style={{ padding: "12px 14px" }}>
                <CardTitle
                    tag="h4"
                    className="text-center mb-0"
                    style={{ color: "#304d78", fontWeight: 700, fontSize: "1.75rem" }}
                >
                    Membership Fee
                </CardTitle>

                <div style={{ marginTop: "10px", marginBottom: "8px" }}>
                    <div style={stripStyle}>
                        <Row className="g-0 row-cols-1 row-cols-sm-2 row-cols-lg-6">
                            {topSegments.map((segment, index) => (
                                <Col key={segment.key}>
                                    <div
                                        style={{
                                            ...segmentStyle,
                                            borderLeft: index === 0 ? "none" : "1px dashed #d7e1ef",
                                        }}
                                    >
                                        <div style={iconWrapStyle}>
                                            <i className={`fa ${segment.icon}`} style={{ color: "#4b6285" }} />
                                            <p style={segmentLabelStyle}>{segment.label}</p>
                                        </div>
                                        <p style={segmentValueStyle}>{segment.value}</p>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </div>
                </div>

                <Row className="g-2">
                    <Col xs={12} lg={6}>
                        <div style={stripStyle}>
                            <Row className="g-0 row-cols-1 row-cols-md-3">
                                {bottomSegments.map((segment, index) => (
                                    <Col key={segment.key}>
                                        <div
                                            style={{
                                                ...segmentStyle,
                                                borderLeft: index === 0 ? "none" : "1px dashed #d7e1ef",
                                            }}
                                        >
                                            <div style={iconWrapStyle}>
                                                <i className={`fa ${segment.icon}`} style={{ color: "#4b6285" }} />
                                                <p style={segmentLabelStyle}>{segment.label}</p>
                                            </div>
                                            <p style={segmentValueStyle}>{segment.value}</p>
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </div>
                    </Col>

                    <Col xs={12} lg={6}>
                        <div
                            style={{
                                minHeight: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-end",
                                padding: "12px 0",
                            }}
                        >
                            <Button
                                color="primary"
                                onClick={onBack}
                                style={{
                                    borderRadius: "999px",
                                    padding: "8px 18px",
                                    fontWeight: 700,
                                    fontSize: "0.9rem",
                                    backgroundColor: "#0052a3",
                                    borderColor: "#0052a3",
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = "#003d7a";
                                    e.currentTarget.style.borderColor = "#003d7a";
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = "#0052a3";
                                    e.currentTarget.style.borderColor = "#0052a3";
                                }}
                            >
                                &larr; Back
                            </Button>
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    );
};

export default TravelSummary;
